import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { showAuthMessage } from "actions/Cantina";
import requisicaoApiCantina from 'util/ApiCantina';
import requisicaoApi from 'util/Api';
import { cantinaPorIdadeSucesso, listaEscolasSucesso, cantinaPorTurmaSucesso, cantinaObterRestricoesSucesso, setCombo, cantinaPorTurma, cantinaPorIdade } from "actions/Cantina";

import {
  INICIO_CANTINA,
  BUSCAR_REGISTRO_CANTINA_IDADE,
  BUSCAR_REGISTRO_CANTINA_TURMA,
  BUSCAR_REGISTRO_RESTRICOES,
  CANTINA_LISTA_ESCOLAS,
} from 'constants/ActionTypes';
/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getBuscarRegistroCantinaIdade = async (idEscola) =>
  await requisicaoApiCantina.get(`/v1/registrocantina/por-idade`, { params: { IdCliente: localStorage.getItem('idClienteFixado'), IdEscola: idEscola } })
    .then(resposta => resposta)
    .catch(error => error);

const getBuscarRestricoes = async (payload) =>
  await requisicaoApiCantina.get(`/v1/registrocantina/restricoes`, { params: {idade: payload.idade, idTurma: payload.idTurma}})
    .then(resposta => resposta)
    .catch(error => error);

const getBuscarRegistroCantinaTurma = async (idEscola) =>
  await requisicaoApiCantina.get(`/v1/registrocantina/por-turma`, { params: { IdCliente: localStorage.getItem('idClienteFixado'), IdEscola: idEscola } })
    .then(resposta => resposta)
    .catch(error => error);

const getEscolas = async () =>
  await requisicaoApiCantina.get(`/v1/registrocantina/escolas/${localStorage.getItem('idClienteFixado')}`)
    .then(res => res)
    .catch(err => err);

const getMensagemErro = (ret, fallback) => {
  const status = ret && ret.response && ret.response.status;
  const data = ret && ret.response && ret.response.data;
  
  if (status === 400 || status === 406) {
    const inconsistencias = (data && data.inconsistencias) || [];
    if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
      return inconsistencias[0].mensagem || JSON.stringify(data);
    }
    return (data && (data.mensagem || data.message)) ? (data.mensagem || data.message) : JSON.stringify(data);
  }
  
  if (ret && ret.message) return JSON.stringify(ret.message);
  return fallback || 'Falha na operação.';
};

/*#################################################################################################################*/
/* ------------------------------------------ Funções das Sagas ---------------------------------------------------*/

export function* iniciaCantina() {
  yield takeEvery(INICIO_CANTINA);
}

export function* buscarRegistroCantinaTurma() {
  yield takeEvery(BUSCAR_REGISTRO_CANTINA_TURMA, fnbuscarRegistroCantinaTurma);
}

export function* buscarRegistroCantinaIdade() {
  yield takeEvery(BUSCAR_REGISTRO_CANTINA_IDADE, fnbuscarRegistroCantinaIdade);
}

export function* buscarRestricoes() {
  yield takeEvery(BUSCAR_REGISTRO_RESTRICOES, fnGetBuscarRestricoes);
}

export function* watchListaEscolas() {
  yield takeEvery(CANTINA_LISTA_ESCOLAS, fnListaEscolas);
}

function* fnGetBuscarRestricoes({payload}) {
  try {
    const retorno = yield call(getBuscarRestricoes, payload);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(cantinaObterRestricoesSucesso(retorno.data));
    }
  } catch (error) {

    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnbuscarRegistroCantinaTurma({payload}) {
  try {
    const retorno = yield call(getBuscarRegistroCantinaTurma, payload.idEscola);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(cantinaPorTurmaSucesso(retorno.data));
    }
  } catch (error) {

    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnbuscarRegistroCantinaIdade( {payload} ) {
  try {
    const retorno = yield call(getBuscarRegistroCantinaIdade, payload.idEscola);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(cantinaPorIdadeSucesso(retorno.data));
    }
  } catch (error) {

    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnListaEscolas() {
  try {
    const res = yield call(getEscolas);
    if (res.status === 200) {
      // API pode retornar array ou objeto único dependendo da permissão/contexto
      // Garantir que seja array para o reducer e componente
      let lista = [];

      if (Array.isArray(res.data)) {
        lista = res.data;
      } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
        // Alguns endpoints retornam { data: [...], ... }
        lista = res.data.data;
      } else if (res.data && res.data.items && Array.isArray(res.data.items)) {
        // Alguns endpoints paginados retornam items
        lista = res.data.items;
      } else if (res.data && typeof res.data === 'object') {
        // Se retornou um objeto único (não null), transforma em array
        // Cuidado com objetos vazios ou estruturas inesperadas
        const values = Object.values(res.data);
        if (values.length > 0 && typeof values[0] === 'object') {
          // Pode ser um map { "1": {id:1...}, "2": {id:2...} }
          lista = values;
        } else {
          lista = [res.data];
        }
      }

      yield put(listaEscolasSucesso(lista));

      if (lista.length == 1) {
        yield put(setCombo(lista[0].id))
        yield put(cantinaPorTurma({ idEscola: lista[0].id }))
        yield put(cantinaPorIdade({ idEscola: lista[0].id }))
      }
    } else {
      yield put(showAuthMessage(getMensagemErro(res, 'Erro ao listar escolas')));
    }
  } catch (error) {
    console.error('SagaCalendario: fnListaEscolas error', error);
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

export default function* rootSaga() {
  yield all([
    fork(buscarRegistroCantinaTurma),
    fork(buscarRestricoes),
    fork(buscarRegistroCantinaIdade),
    fork(watchListaEscolas),
  ]);
}
